import { Link } from "react-router-dom";
import { communityValues } from "@/mocks/site";

const tones = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
  "bg-primary-100 text-primary-700",
];

export default function CommunityValues() {
  return (
    <section id="values" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-widest text-primary-600">WHY HERE</span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              为什么大家愿意留在瓜田
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              一个社区能不能待下去，不看功能有多少，只看说话的人是不是让人舒服。这四条，是瓜田一直在守的底线。
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              了解社区的内容原则
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-8">
            {communityValues.map((value, index) => (
              <div
                key={value.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${tones[index]}`}
                >
                  <i className={value.icon} />
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">{value.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}